module.exports = __webpack_public_path__ + "img/collapse.a5dfbe7b.svg";